import PostGrid from "@components/grid/PostGrid";
import { AttrProps } from "@customTypes/index";
import useResponsiveCmsSettings from "@hooks/useResponsiveCmsSettings";
import { CmsBreakPointsDefaults } from "@lib/constants";
import { Col, Layout, Row, Space } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";

interface DataProps {
    className?: string;
    attrs: AttrProps;
    results: any[];
    details: any;
}

const defaultProps: DataProps = {
    results: [],
    details: {},
    attrs: {
        breakpoints: {
            desktop: {
                total: CmsBreakPointsDefaults.DESKTOP.TOTAL
            },
            tablet: {
                total: CmsBreakPointsDefaults.TABLET.TOTAL
            },
            mobile: {
                total: CmsBreakPointsDefaults.MOBILE.TOTAL
            },
        }
    }
};

const YoutubeSearch = ({ className, attrs, results, details }: DataProps) => {
    const css: any = ["covr-youtube-search"];
    const { total } = useResponsiveCmsSettings(attrs.breakpoints)
    const [items, setItems] = useState(results);

    if (className) {
        css.push(className);
    }

    useEffect(() => {
        if (total && results) {
            let cleanUpResults = results
                ?.map(item => {
                    return {
                        id: item.statistics.videoId,
                        title: item.details.title,
                        date: moment(item.details.publishedAt)
                            .format("MMMM Do, YYYY - HH:mm:ss"),
                        description: `${item.statistics.viewCount} Views, ${item.statistics.likeCount} Likes`,
                        image: {
                            src: item.details.thumbnails.medium.url,
                            alt: item.details.title
                        },
                        link: {
                            url: item?.url,
                            title: item?.details?.title,
                            target: '_blank'
                        }
                    }
                });

            let updatedItems = [...cleanUpResults];
            updatedItems = updatedItems.splice(0, total);

            setItems(total === results.length ? cleanUpResults : updatedItems);
        }
    }, [total, results])

    return (
        <Layout className={css}>
            <Row className="data-header">
                <Col>
                    <Space>
                        {details?.icon
                            && <img
                                className="channel-avatar"
                                width={`80`}
                                height={`80`}
                                src={details.icon} alt="logo"
                            />}
                        <div>
                            {details?.name &&
                                <h3>
                                    {attrs.title !== '' ? attrs.title : details.name}
                                </h3>}
                            <p>
                                {details?.url &&
                                    <a href={`https://www.youtube.com/${details.url}`}>
                                        {details.url}
                                    </a>}
                                <br />

                                {details?.subscriberCount
                                    && details.subscriberCount
                                }
                            </p>
                        </div>
                    </Space>
                </Col>
            </Row>

            <Row justify={`center`} className="data-body">
                <Col>
                    {items &&
                        <PostGrid
                            {...attrs}
                            data={items}
                        />
                    }
                </Col>
            </Row>

            <Row className="data-footer" justify="end">
                <Col>
                    {(attrs?.link?.url || details?.url) &&
                        <a
                            target="_blank"
                            rel="noreferrer"
                            className="view-all"
                            href={attrs.link?.url || `https://www.youtube.com/${details.url}`}
                        >
                            {attrs.link?.title || `Go To Channel`}
                        </a>}
                </Col>
            </Row>
        </Layout>
    );
};

YoutubeSearch.defaultProps = defaultProps;

export default YoutubeSearch;
